import React, { useEffect, useState } from "react";
import { getSettingDefaultListRequest } from "../api/requests";
import { getAppToken } from "../api/sessions";

const ThemeSettingsFromApi = () => {
  const [styles, setStyles] = useState<any>(null);

  useEffect(() => {
    const token = getAppToken();
    if (token && token !== "undefined" && token !== "") {
      getSettingDefaultListRequest()
        .then((response) => {
          if (response?.resCode === 200 && response?.dataSet?.length > 0) {
            try {
              const json = JSON.parse(response.dataSet[0].settingJson);
              setStyles(json);
            } catch (e) {
              console.error("Error parsing setting JSON:", e);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching default settings:", error);
        });
    }
  }, []);

  if (!styles) return null;

  return (
    <style>
      {`
        .custom-grid .dx-datagrid-rowsview .dx-row td {
          padding-block: ${styles.grid_row_padding ?? 3}px !important;
          font-size: ${styles.grid_row_font ?? 12}px !important;
          font-weight: ${styles.grid_row_bold ? "bold" : "normal"} !important;
          font-family: ${styles.grid_row_fontfamily ?? "'Arial', sans-serif"} !important;
        }

        .custom-grid .dx-datagrid-headers .dx-datagrid-text-content {
          padding-block: ${styles.grid_header_padding ?? 0}px !important;
          font-size: ${styles.grid_header_font ?? 12}px !important;
          font-weight: ${styles.grid_header_bold ? "bold" : "normal"} !important;
          font-family: ${styles.grid_header_fontfamily ?? "'Arial', sans-serif"} !important;
        }

        .dx-theme-fluent .dx-widget {
          font-family: ${styles.menu_fontfamily ?? "'Arial', sans-serif"} !important;
          font-size: ${styles.menu_fontsize ?? 14}px !important;
        }

        .dx-texteditor-input {
          font-family: ${styles.menu_fontfamily ?? "'Arial', sans-serif"} !important;
        }

        .title-text {
          font-family: ${styles.menu_fontfamily ?? "'Arial', sans-serif"} !important;
          font-weight: bold;
          font-size: 18px;
          margin-top: 4px;
          margin-left: 4px;
        }


      `}
    </style>
  );
};

export default ThemeSettingsFromApi;
